import { render, staticRenderFns } from "./FormVerifyOtp.vue?vue&type=template&id=220dfc42&scoped=true"
import script from "./FormVerifyOtp.vue?vue&type=script&lang=js"
export * from "./FormVerifyOtp.vue?vue&type=script&lang=js"
import style0 from "./FormVerifyOtp.vue?vue&type=style&index=0&id=220dfc42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220dfc42",
  null
  
)

export default component.exports